import { h, Component } from 'preact';
import Content from '../content/content';
import Border from '../border/border';
import Header from '../header/header';
import styles from './hero.css';

export default class Hero extends Component {
  render() {
    return (<div className={styles.container}>
      <Header />
      <Content>
        <div className={styles.text}>
          <h2 className={styles.title}>You've found trouble!</h2>
          <h2 className={styles.subTitle}>Personalised brewing for businesses and events, both big and small</h2>
        </div>
      </Content>
      <Border color="white" />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/hero/hero.jsx